export default __webpack_public_path__ + "static/media/purple.d931c935.jpg";